/**
 * Application version utility
 * Centralized version management for the application
 */

export const APP_VERSION = 'V1.5.4'

export const getVersionText = () => {
  return `AI Driven Document Classification : ${APP_VERSION}`
}

export const getVersion = () => {
  return APP_VERSION
}
